import { render } from "./HeadSelector.vue?vue&type=template&id=4bc7983e"
import script from "./HeadSelector.vue?vue&type=script&lang=js"
export * from "./HeadSelector.vue?vue&type=script&lang=js"

import "./HeadSelector.vue?vue&type=style&index=0&id=4bc7983e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__